import { SelectListItem, SmartSelectItem } from '@components-deprecated'

import React from 'react'

export const OrganizationSelectItem = ({ id, ...rest }: SmartSelectItem) => (
  <SelectListItem key={id} id={id} {...rest} />
)
